
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Checkbox,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import { copyToClipboard } from "Core/data/Helpers"

//Notification
import { NotificationManager } from "Components/Notifications";

//Actions
import {
    markAsRmaGetDeviceRequest,
    markAsRmaSetDevice,
    markAsRmaRequest,
    clearRedux,
} from 'Redux/actions';

const MarkAsRma = (props) => {
    const formRef = useRef(null);
    const formTwoRef = useRef(null);
    const { messages } = useIntl();
    const { tableRef, single, getDevice } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate()

    //Redux States
    const { device, loading, openModal, result, devices, selectedDevices } = useSelector(state => state.markAsRmaRedux)

    //Local States
    const [serial, setSerial] = useState("");
    const [show, setShow] = useState(false);
    const [reference, setReference] = useState("");
    const [step, setStep] = useState(1);

    const searchDevice = () => {
        dispatch(markAsRmaGetDeviceRequest(serial?.trim()));
    }

    const closeModal = () => {
        setSerial("");
        setStep(1);
        setShow(false);
        setReference("");
        dispatch(clearRedux("MARK_AS_RMA"));
    }

    const applyChanges = () => {
        let unitIds = devices.map((item) => (item?.id))
        let payload = {
            features: {
                show: show
            },
            reference: reference,
            status: 6, //RMA Status is 6
            unitIds
        }
        dispatch(markAsRmaRequest(payload))
    }

    useEffect(() => {
        if (device) {
            if (!device?.total) {
                NotificationManager.warning(
                    messages['mark_as_rma_device_has_not_been_found'],
                    messages['mark_as_rma_title'],
                    3000
                );
            } else {
                let currentDevices = devices;
                let newDevice = device?.items[0];
                let validateNewDevice = currentDevices.some((item) => item.id === newDevice.id);

                if (validateNewDevice) {
                    setSerial("");
                    NotificationManager.warning(
                        messages['mark_as_rma_device_is_already_added'],
                        messages['mark_as_rma_title'],
                        3000
                    );

                } else if (newDevice.status === 6) {
                    setSerial("");
                    NotificationManager.warning(
                        messages['mark_as_rma_device_is_already_rma'],
                        messages['mark_as_rma_title'],
                        3000
                    );
                } else if (newDevice?.refurbishedUnit?.refurbishedUnitId) {
                    setSerial("");
                    NotificationManager.warning(
                        messages['mark_as_rma_device_is_already_refirbished'],
                        messages['mark_as_rma_title'],
                        3000
                    );
                } else {
                    currentDevices.push(newDevice);
                    setSerial("");
                    dispatch(markAsRmaSetDevice(currentDevices))
                }
            }
            dispatch(clearRedux("MARK_AS_RMA", { device: null }))
        }
        if (result?.markAsRma) {
            
            closeModal();
            let transactionId = result?.markAsRma?.transactionId;
            let message = messages["mark_as_rma_transaction_message"]
            NotificationManager.success(message, messages['mark_as_rma_title'], 10000, () => {
                copyToClipboard(transactionId, messages['common_copied']);
                navigate(`/app/transactions/list/${transactionId}`);

            }, null, '', null);

            getDevice && getDevice();
            tableRef && tableRef?.current?.getData();
        } else if (result && !result?.markAsRma) {
            NotificationManager.error(
                messages['mark_as_rma_error_message'],
                messages['mark_as_rma_title'],
                3000
            );
            dispatch(clearRedux("MARK_AS_RMA", { result: null }))
        }
        if (selectedDevices && selectedDevices.length > 0) {
            let newDevices = selectedDevices.map((item) => ({ id: item?.id, imei: item?.imei, esn: item?.esn, deviceModel: item?.deviceModel }));
            dispatch(markAsRmaSetDevice(newDevices));
            dispatch(clearRedux("MARK_AS_RMA", { selectedDevices: [] }))
        }
    }, [device, result, selectedDevices])

    let validateStepOne = step === 1 && !single
    let validateStepTwo = step === 2 || single

    return (
        <Modal
            open={openModal}
            title={messages['mark_as_rma_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                {
                    validateStepOne &&
                    <div style={{ padding: '0 10px' }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={10}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    <Input
                                        label={messages['mark_as_rma_input']}
                                        placeholder={messages['mark_as_rma_input']}
                                        value={serial}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setSerial(value)}
                                    />
                                </Form>
                            </Grid>
                            <Grid item xs={2}>
                                <div style={{ marginTop: 26 }}>
                                    <Button
                                        className="btn-dark-blue"
                                        onClick={() => formRef?.current?.submit()}
                                    >
                                        {messages['common_add']}
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        {devices?.length > 0 ? devices.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = devices;
                                        let selected = currentDevices.findIndex((device) => device.id === item.id);
                                        if (selected > -1) currentDevices.splice(selected, 1);
                                        dispatch(markAsRmaSetDevice(currentDevices));
                                    }}
                                >
                                    <div style={{ display: 'grid' }}>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['mark_as_rma_imei']}</label><span>{item.imei}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['mark_as_rma_serial']}</label><span>{item.esn}</span>
                                        </div>
                                        <div>
                                            <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['mark_as_rma_model']}</label><span>{item?.deviceModel?.name}</span>
                                        </div>
                                    </div>
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{messages['common_no_devices_added']}</span></div>}
                    </div>
                }
                {
                    validateStepTwo &&
                    <div style={{ padding: '0 10px' }}>
                        <Form
                            ref={formTwoRef}
                            onValidSubmit={() => applyChanges()}
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <Input
                                        label={messages['mark_as_rma_number']}
                                        placeholder={messages['mark_as_rma_number']}
                                        value={reference}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setReference(value)}
                                        regex={"^[0-9]*$"}
                                        minLength={5}
                                        maxLength={15}
                                        minLengthMessage={messages["mark_as_rma_min_message"]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Checkbox
                                        id="tab-show-in-web"
                                        label={messages['mark_as_rma_show_in_web']}
                                        value={show}
                                        onChange={(checked) => {
                                            setShow(checked);
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Form>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                {step === 2 && !single &&
                    <Button
                        className="btn btn-cancel btn-gray"
                        onClick={() => setStep(1)}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    disabled={step === 1 && devices.length === 0}
                    className="btn-dark-blue"
                    onClick={() => {
                        if (single) formTwoRef?.current?.submit();
                        else {
                            if (step < 2) setStep(step + 1);
                            else formTwoRef?.current?.submit();
                        }
                    }}
                >
                    {step === 1 && !single ? messages['common_next'] : messages['mark_as_rma_change']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default MarkAsRma;